import React from 'react'

const PhotoGallery = () => {
  return (
    <>
      {/* END USER PROFILE MENU POPUP */}
      {/* START */}
      <section>
        <div className="inn-ban">
          <div className="container">
            <div className="row">
              <h1>Photo gallery</h1>
              <p>
                lacinia viverra lectus. Fusce imperdiet ullamcorper metus eu
                fringilla
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* END */}
      {/* START */}
      <section>
        <div className="wedd-gall wedd-gall-pg">
          <div className="">
            <div className="gall-inn">
              <div className="col-lg-2 col-md-4 col-sm-6">
                <div className="gal-im"
                //  animate animate__animated animate__slow animate__flipInX anistart"
                >
                  <img
                    src="images/gallery/1.jpg"
                    className="gal-siz-1"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
                <div
                  className="gal-im "
                // animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/gallery/9.jpg"
                    className="gal-siz-2"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="gal-im"
                //  animate animate__animated animate__slower animate__flipInX anistart"
                >
                  <img
                    src="images/gallery/3.jpg"
                    className="gal-siz-2"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
                <div
                  className="gal-im"
                //  animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/gallery/4.jpg"
                    className="gal-siz-1"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6">
                <div className="gal-im"
                //  animate animate__animated animate__slower animate__flipInX anistart"
                >
                  <img
                    src="images/gallery/5.jpg"
                    className="gal-siz-1"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
                <div
                  className="gal-im"
                //  animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/gallery/6.jpg"
                    className="gal-siz-2"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div className="gal-im"
                // animate animate__animated animate__slower animate__flipInX anistart"
                >
                  <img
                    src="images/gallery/7.jpg"
                    className="gal-siz-2"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
                <div
                  className="gal-im "
                // animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/gallery/8.jpg"
                    className="gal-siz-1"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6">
                <div className="gal-im"
                // animate animate__animated animate__slower animate__flipInX anistart"
                >
                  <img
                    src="images/couples/1.jpg"
                    className="gal-siz-2"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
                <div
                  className="gal-im "
                // animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/couples/11.jpg"
                    className="gal-siz-1"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6">
                <div
                  className="gal-im"
                //  animate animate__animated animate__slow"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/couples/2.jpg"
                    className="gal-siz-1"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
                <div
                  className="gal-im"
                // animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/couples/3.jpg"
                    className="gal-siz-2"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div
                  className="gal-im"
                //  animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/couples/4.jpg"
                    className="gal-siz-2"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
                <div
                  className="gal-im"
                //  animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/couples/5.jpg"
                    className="gal-siz-1"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-6">
                <div
                  className="gal-im"
                //  animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/couples/6.jpg"
                    className="gal-siz-1"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
                <div
                  className="gal-im"
                //  animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/couples/7.jpg"
                    className="gal-siz-2"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6">
                <div
                  className="gal-im "
                // animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/couples/8.jpg"
                    className="gal-siz-2"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
                <div
                  className="gal-im"
                //  animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/couples/9.jpg"
                    className="gal-siz-1"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-12 col-sm-6">
                <div
                  className="gal-im"
                //  animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/couples/10.jpg"
                    className="gal-siz-2"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
                <div
                  className="gal-im"
                //  animate animate__animated animate__slower"
                // data-ani="animate__flipInX"
                >
                  <img
                    src="images/couples/11.jpg"
                    className="gal-siz-1"
                    alt=""
                    loading="lazy"
                  />
                  <div className="txt">
                    <span>Wedding</span>
                    <h4>Bride &amp; Groom</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* END */}

    </>

  )
}

export default PhotoGallery